export const AdminNotificationConfigController = {
    index(): void {},
    update(): void {},
    toggle(): void {},
};
